import { render, staticRenderFns } from "./MyOffers.vue?vue&type=template&id=63383be4&"
import script from "./MyOffers.vue?vue&type=script&lang=js&"
export * from "./MyOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports